
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {
    display: block;
}
.event-card {
    background-color: var(--bh-neutral-white);
    font-family: var(--ff-display);
    font-size: var(--fs-base);
    line-height: var(--lh-base);
    font-weight: var(--fw-semibold);
}
.event-card-heading {
    font-size: var(--fs-lg);
    line-height: var(--lh-lg);
    font-weight: var(--fw-bold);
    color: var(--primary-blue-light-2);
}
@media (min-width: 640px) {
    .event-card-heading {
        font-size: var(--fs-xl);
        line-height: var(--lh-xl);
    }
}
.event-card-heading {
    margin-bottom: 1rem;
}
.event-card-openings {
    display: flex;
    align-items: center;
    font-family: var(--ff-body);
    color: var(--primary-green);
}
.event-card-openings ghs-icon {
    margin-right: 0.5rem;
}
.event-card-description {
    margin-top: 1rem;
    margin-bottom: 1rem;
}
.event-card-cta {
    margin-top: 1rem;
}
:host([site='BH']) .event-card {
    width: auto;
}
:host([site='BH']) .event-card {
    max-width: 28rem;
}
:host([site='BH']) .event-card {
    border-radius: 0.375rem;
}
:host([site='BH']) .event-card {
    border-width: 1px;
}
:host([site='BH']) .event-card {
    border-style: solid;
}
:host([site='BH']) .event-card {
    border-color: var(--bh-neutral-default);
}
:host([site='BH']) .event-card {
    padding: 1.5rem;
}
:host([site='BH']) .event-card-heading, :host([site='BH']) .event-card-description, :host([site='BH']) .event-card-date-time {
    font-family: var(--bh-ff-body);
}
:host([site='BH']) .event-card-heading, :host([site='BH']) .event-card-description, :host([site='BH']) .event-card-date-time {
    font-weight: var(--fw-normal);
}
:host([site='BH']) .event-card-heading, :host([site='BH']) .event-card-description, :host([site='BH']) .event-card-date-time {
    color: var(--bh-neutral-black);
}
:host([site='BH']) .event-card-heading {
    font-weight: var(--fw-bold);
}
:host([site='BH']) .event-card-heading ::slotted(*) {
    font-size: var(--bh-fs-heading-03);
    line-height: var(--bh-lh-heading-03);
    letter-spacing: var(--bh-ls-heading-03);
}
:host([site='BH']) .event-card-date-time {
    display: flex;
}
:host([site='BH']) .event-card-date-time {
    align-items: center;
}
:host([site='BH']) .event-card-date-time {
    font-size: var(--bh-fs-body-01);
    line-height: var(--bh-lh-body-01);
    letter-spacing: var(--bh-ls-body-01);
}
:host([site='BH']) .event-card-date-time {
    font-weight: var(--fw-bold);
}
:host([site='BH']) .event-card-date-time ghs-icon {
    margin-right: 0.5rem;
}
:host([site='BH']) .event-card-description {
    font-size: var(--bh-fs-body-01);
    line-height: var(--bh-lh-body-01);
    letter-spacing: var(--bh-ls-body-01);
}
:host([site='BH']) .event-card-description {
    font-weight: var(--fw-normal);
}
:host([site='BH']) .event-card-cta {
    border-width: 0px;
}
:host([site='BH']) .event-card-cta {
    border-top-width: 1px;
}
:host([site='BH']) .event-card-cta {
    border-style: solid;
}
:host([site='BH']) .event-card-cta {
    border-top-color: var(--bh-neutral-default);
}
:host([site='BH']) .event-card-cta {
    padding-top: 1rem;
}
:host([site='BH']) .event-card-cta ::slotted(*) {
    font-size: var(--bh-fs-body-02);
    line-height: var(--bh-lh-body-02);
    letter-spacing: var(--bh-ls-body-02);
}
:host([site='BH']) .event-card-cta ::slotted(*) {
    font-weight: var(--fw-bold);
}
:host([height-grow]) {
    display: block;
    height: 100%;
}
:host([height-grow]) .event-card {
    display: flex;
}
:host([height-grow]) .event-card {
    height: 100%;
}
:host([height-grow]) .event-card {
    flex-direction: column;
}
:host([height-grow]) .event-card .event-card-description {
    flex-grow: 1;
}
`;